import axios from "axios";
import {
  GET_SEARCHBAR_DATA_REQUEST,
  GET_SEARCHBAR_DATA_FAIL,
  GET_SEARCHBAR_DATA_SUCCESS,
} from "../../types/admin/searchbarTypes";

//Searchbar List
export const getSearchbarListAction = (title) => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_SEARCHBAR_DATA_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/searchbar/data/`,
      { title },
      config
    );
    // console.log(data);
    dispatch({
      type: GET_SEARCHBAR_DATA_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: GET_SEARCHBAR_DATA_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};
